/**
 * 关闭所有视窗
 * 目前适用于随管家
 */
import useragent from '@common/useragent'
import { call } from './bridge'

export default () => {
  if (useragent.isSuiguanjia) {
    call('sgj://app/webview/allClose')
  }
}



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/closeAllView.js